module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate2_m.aedde915f06905b30ea49bd7965ad09c.png";